<!-- eslint-disable vue/no-mutating-props -->
<template>
    <!--Planning de servicio-->
    <div class="alert alert-danger" v-if="errorPlanning" style="text-align: center;">
        <h5 style="color: white;">Debe rellenar el tipo de daño para mostrar el planning</h5>
    </div>
    <div class="row" v-else>
        <div :class="clase">
            <!-- IPAS -->
            <div class="row" v-if="servicio?.precita_ipas">
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title"><i class="fas fa-calendar-alt mr-2"></i>Confirmar cita preasignada
                            </h3>
                            <div class="card-tools">
                                <button type="button" class="btn btn-tool editar-asegurado" title="Mostrar/ocultar" v-on:click="mostrar=!mostrar">
                                    <i class="fas fa-plus" v-if="mostrar == false"></i>
                                    <i class="fas fa-minus" v-if="mostrar == true"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card-body p-0" v-if="mostrar">
                            <div class="row" style="margin-left:10px;margin-top:10px;margin-right:10px">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="fechainicioipas">{{ $t('general.FechaInicio') }}</label><br>
                                        <Calendar style="width: 100%;"
                                            inputId="fechainicioipas"
                                            :modelValue="fechainicioipas"
                                            @update:modelValue="cambiarFechaInicioIpas"
                                            class="inputfecha selector-filtro" showTime hourFormat="24"
                                            :stepMinute="10" dateFormat="dd/mm/yy" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="fechafinipas">{{ $t('general.fechafin') }}</label><br>
                                        <Calendar style="width: 100%;"
                                            inputId="fechafinipas"
                                            :modelValue="fechafinipas"
                                            @update:modelValue="val => fechafinipas = limitarFranja(val)"
                                            class="inputfecha selector-filtro" showTime hourFormat="24"
                                            :stepMinute="10" dateFormat="dd/mm/yy" />
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="margin-left:10px;margin-right:10px">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="especialidadipas">Especialidad</label><br>
                                        <select id="especialidadipas" style="width: 100%;" v-model="ipasespecialidad" @change="obtenerOperariosEspecialidadIpas(ipasespecialidad)" class="form-control form-control-sm">
                                            <option selected value="">Seleccione especialidad</option>
                                            <option :value="especi.id_especialidad" v-for="especi in especioperario"
                                                :key="especi.id_especialidad">{{ especi.nombre }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="operarioipas">Operario</label><br>
                                        <select id="operarioipas" v-if="ipasespecialidad && operariosespecialidadipas" v-model="ipasoperario" style="width: 100%;" class="form-control form-control-sm">
                                            <option selected value="">Seleccione Operario</option>
                                            <option v-for="operario in operariosespecialidadipas" :key="operario.idoperario" :value="operario.idoperario">{{ operario.nombre }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="prestacionipas">Prestación</label><br>
                                        <select id="prestacionipas" v-model="prestacionipasseleccionada" style="width: 100%;" class="form-control form-control-sm">
                                            <option v-for="prestacion in prestacionesipas" :key="prestacion.numero_prestacion" :value="prestacion.numero_prestacion">{{ prestacion.gremio }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="margin-left:10px;margin-right:10px">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="descripcionvisitaipas">Descripción visita</label><br>
                                        <Textarea placeholder="Descripción de la visita" style="width: 100%;" autoResize id="descripcionvisitaipas" cols="30" v-model="descripcionvisitaipas"></Textarea>
                                        <label>{{ descripcionvisitaipas.length }} carácteres. Mínimo 25 Caracteres.</label><br>
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="margin-left:10px;margin-right:10px">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Documentos rellenar operario</label><br>
                                        <div class="row" style="margin-left:10px;" v-for="documentos in documentacionipas" :key="documentos.id">
                                            <Checkbox :modelValue="documentos.checked == 'checked'" binary @update:modelValue="val => documentos.checked = val ? 'checked' : ''" />&nbsp; {{ documentos.nombre }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Grupo campos rellenar operario</label><br>
                                        <div class="row" style="margin-left:10px;" v-for="campos in camposrellenaripas" :key="campos.id">
                                            <Checkbox :modelValue="campos.checked == 'checked'" binary @update:modelValue="val => campos.checked = val ? 'checked' : ''" />&nbsp; {{ campos.nombre }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="margin-left:20px;margin-right:10px;margin-bottom:10px">
                                <Button @click="enviarprecitaIpas()" class=" btn btn-primary btn-sm">Guardar</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- INTERPWGS-->
            <div class="row" v-if="visitasinterpwgs && visitasinterpwgs.length">
                <div class="col-md-6" v-for="visitainter in visitasinterpwgs" :key="visitainter.id_mensaje">
                    <div class="card">
                        <div class="card-header ">
                            <h3 class="card-title"><i class="fas fa-calendar-alt mr-2"></i><span v-html="visitainter.info_mensaje"></span>
                            </h3>
                        </div>
                        <div class="card-body p-0">
                            <div class="row" style="margin-left:10px;margin-top:10px;margin-right:10px">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label :for="'fechainiciointer' + visitainter.id_mensaje">{{ $t('general.FechaInicio') }}</label><br>
                                            <Calendar style="width: 100%;"
                                            :inputId="'fechainiciointer' + visitainter.id_mensaje"
                                            :modelValue="visitainter.fecha_inicio_obj"
                                            @update:modelValue="val => cambiarFechaInicioInter(visitainter, val)"
                                            :disabled="esCitaInterConfirmada(visitainter)"
                                            class="inputfecha selector-filtro" showTime hourFormat="24"
                                            :stepMinute="10" dateFormat="dd/mm/yy" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label :for="'fechafininter' + visitainter.id_mensaje">{{ $t('general.fechafin') }}</label><br>
                                            <Calendar style="width: 100%;"
                                            :inputId="'fechafininter' + visitainter.id_mensaje"
                                            :modelValue="visitainter.fecha_fin_obj"
                                            @update:modelValue="val => visitainter.fecha_fin_obj = limitarFranja(val)"
                                            :disabled="esCitaInterConfirmada(visitainter)"
                                            class="inputfecha selector-filtro" showTime hourFormat="24"
                                            :stepMinute="10" dateFormat="dd/mm/yy" />
                                    </div>
                                </div>
                                <div class="col-md-3" v-if="!esCitaInterConfirmada(visitainter)">
                                    <br>
                                    <br>
                                    <div class="custom-control custom-checkbox">
                                        <input v-model="visitainter.confirmar_cita" class="custom-control-input" type="checkbox"
                                        :id="'confirmarcita' + visitainter.id_mensaje"
                                        true-value="1" false-value="">
                                        <label style="font-weight: normal;" :for="'confirmarcita' + visitainter.id_mensaje" class="custom-control-label">Mantener por
                                        confirmar</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="margin-left:10px;margin-right:10px">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label :for="'especialidadinter' + visitainter.id_mensaje">Especialidad</label><br>
                                        <select :id="'especialidadinter' + visitainter.id_mensaje" style="width: 100%;" v-model="visitainter.especialidadseleccionada" @change="obtenerOperariosEspecialidad(visitainter.especialidadseleccionada)" class="form-control form-control-sm">
                                            <option selected value="">Seleccione especialidad</option>
                                            <option :value="especi.id_especialidad" v-for="especi in especioperario"
                                                :key="especi.id_especialidad">{{ especi.nombre }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label :for="'operariointer' + visitainter.id_mensaje">Operario</label><br>
                                        <select :id="'operariointer' + visitainter.id_mensaje" v-if="visitainter.especialidadseleccionada && operariosespecialidad" v-model="visitainter.operarioseleccionado" style="width: 100%;" class="form-control form-control-sm">
                                            <option v-for="operario in operariosespecialidad" :key="operario.idoperario" :value="operario.idoperario">{{ operario.nombre }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="margin-left:10px;margin-right:10px">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label :for="'descripcionvisitainter' + visitainter.id_mensaje">Descripción visita</label><br>
                                        <Textarea placeholder="Descripción de la visita" style="width: 100%;" autoResize :id="'descripcionvisitainter' + visitainter.id_mensaje" cols="30" v-model="visitainter.descripcion"></Textarea>
                                        <label>{{ (visitainter.descripcion || '').length }} carácteres. Mínimo 25 Caracteres.</label><br>
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="margin-left:10px;margin-right:10px">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Documentos rellenar operario</label><br>
                                        <div class="row" style="margin-left:10px;" v-for="documentos in visitainter.documentos_mensaje" :key="documentos.id">
                                            <Checkbox :modelValue="documentos.checked == 'checked'" binary @update:modelValue="val => documentos.checked = val ? 'checked' : ''" />&nbsp; {{ documentos.nombre }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="margin-left:20px;margin-right:10px;margin-bottom:10px">
                                <Button @click="enviarcitainterpwgs(visitainter)" class=" btn btn-primary btn-sm">Guardar</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- INTERPWGS-->
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header bg-gray">
                            <h3 class="card-title"><i class="fas fa-calendar-alt mr-2"></i>{{ $t('general.Visitas') }}
                            </h3>
                            <div class="card-tools d-flex align-items-center">
                                <div v-if="servicio?.PAS" class="d-inline-block me-2" style="margin:0;padding:0;">
                                    <input v-model="servicio.PAS.rga" type="checkbox" id="rga" true-value="1" false-value="" @change="modificarPAS()">
                                    <label class="ml-1" style="margin:0;" for="rga">RGA</label>
                                </div>
                                <button type="button" class="btn btn-tool" data-card-widget="maximize">
                                    <i class="fas fa-expand"></i>
                                </button>
                                <button type="button" class="btn btn-tool" :title="titulo" v-on:click="mapacalendario()">
                                    <i :class="iconomapa"></i>
                                </button>
                                <button v-if="component == 'servicio-planning-calendario'" type="button" class="btn btn-tool" title="Leyenda" @click="toggle">
                                    <i class="fas fa-info"></i>
                                </button>
                                <!--<button v-if="component == 'servicio-planning-calendario'" type="button"
                                    class="btn btn-tool" title="Filtro"
                                    v-on:click="mostrarfiltroavz = !mostrarfiltroavz;mostrarfiltrooperarios =false;">
                                    <i class="fas fa-filter"></i>
                                </button>
                                <button type="button" class="btn btn-tool" title="ensanchar"
                                    v-on:click="cambiarclase()">
                                    <i :class="icono"></i>
                                </button>-->
                                <OverlayPanel ref="op">
                                    <h4 style="text-align:center">{{ $t('general.leyenda') }}</h4>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td style="width: 228px;background-color: rgb(52, 131, 171)">{{
                                                    $t('general.operarioocupado') }}</td>
                                            </tr>
                                            <tr>
                                                <td style="width: 228px;background-color: rgb(235, 235, 235)">{{
                                                    $t('general.finalizadas') }}</td>
                                            </tr>
                                            <tr>
                                                <td style="width: 228px;background-color: rgb(255, 232, 140)">{{
                                                    $t('general.pendientes') }}</td>
                                            </tr>
                                            <tr>
                                                <td style="width: 228px;background-color: rgb(245, 197, 5)">
                                                    En domicilio
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    style="width: 228px; position:unset !important;background-color: rgb(0, 204, 0)">
                                                    {{ $t('general.vacaciones') }}</td>
                                            </tr>
                                            <tr>
                                                <td
                                                    style="width: 228px;background-color:#476268; color: #eee;font-size:12px;">
                                                    {{ $t('general.bloqueado') }}</td>
                                            </tr>
                                            <tr>
                                                <td style="width: 228px;background-color: #cb55ac;">{{
                                                    $t('general.prioritaria') }}</td>
                                            </tr>
                                            <tr>
                                                <td style="width: 228px;background-color: rgb(252, 175, 62)">{{
                                                    $t('general.conprecita') }}</td>
                                            </tr>
                                            <tr>
                                                <td style="width: 228px;background-color: rgb(255, 70, 70)">
                                                    <div>{{ $t('general.porconfirmar') }}</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </OverlayPanel>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <!--<keep-alive>-->
                            <div v-if="component=='servicio-planning-calendario' && mostrarfiltroavz">
                                <!--div class="row">
                                    <div class="col-md-3">
                                    </div>
                                    <div class="col-md-6">
                                        <select v-model="especioperarioseleccionado" class="form-control form-control-sm">
                                            <option value="">{{ $t('general.Selecciona Especialidad') }}</option>
                                            <option :value="especi.id_especialidad" v-for="especi in especioperario"
                                                :key="especi.id_especialidad">{{especi.nombre}}</option>
                                        </select>
                                    </div>
                                </div>-->
                                <div class="row">
                                    <div class="fila-filtros-uniforme">
                                        <!--<Button type="button" icon="pi pi-calendar" style="height: 90%;margin-left:25%"
                                            title="Calendario" v-on:click="togglecalen"></Button>-->

                                        <Button 
                                            type="button" 
                                            icon="pi pi-filter-slash" 
                                            class="p-button-sm p-button-outlined btn-reinicio" 
                                            style="border-radius: 8px;"
                                            title="Reiniciar Filtros" 
                                            @click="reiniciarfiltros()">
                                        </Button>

                                        <MultiSelect v-model="operariosseleccionados" placeholder="Selecciona operario"
                                        :options="operariosagrupados" optionLabel="nombre" optionValue="idoperario" filter
                                        optionGroupLabel="label" optionGroupChildren="items" display="chip"
                                        :maxSelectedLabels="10" selectedItemsLabel="'{0} Operarios Seleccionados'"
                                        scrollHeight="400px" class="selector-filtro" size="small"/>

                                        <select v-model="especioperarioseleccionado" class="form-control form-control-sm selector-filtro">
                                            <option value="" selected="true" hidden disabled="disabled">{{
                                                $t('general.Selecciona Especialidad') }}</option>
                                            <option :value="especi.id_especialidad" v-for="especi in especioperario"
                                                :key="especi.id_especialidad">{{ especi.nombre }}</option>
                                        </select>

                                        <select v-if="gestiontipos == true" v-model="tiposservicioseleccionado" class="form-control form-control-sm selector-filtro">
                                            <option selected="true" hidden disabled="disabled" value="">{{
                                                $t('general.Tipo de Servicio') }}</option>
                                            <option :value="servicio.id" v-for="servicio in tiposservicio"
                                                :key="servicio.id">{{ servicio.nombre }}</option>
                                        </select>

                                        <select v-if="satactivado" v-model="marcaseleccionada" class="form-control form-control-sm selector-filtro">
                                            <option selected="true" hidden disabled="disabled" value="">{{
                                                $t('general.Marca') }}</option>
                                            <option :value="marca.id_marca" v-for="marca in marcas"
                                                :key="marca.id_marca">{{ marca.nombre_marca }}</option>
                                        </select>

                                        <select v-if="satactivado" v-model="sat" class="form-control form-control-sm selector-filtro">
                                            <option selected="true" hidden disabled="disabled" value="">SAT</option>
                                            <option value="1">SAT {{ $t('general.si') }}</option>
                                            <option value="0">SAT {{ $t('general.no') }}</option>
                                        </select>

                                        <select v-if="guardias==true" v-model="guardia" class="form-control form-control-sm selector-filtro">
                                            <option selected="true" hidden disabled="disabled" value="">{{
                                                $t('general.guardia') }}</option>
                                            <option :value="true">{{ $t('general.guardia') }} {{ $t('general.si') }}
                                            </option>
                                            <option :value="false">{{ $t('general.guardia') }} {{ $t('general.no') }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <select v-if="soporte==1" v-model="mostrarplaningnuevo">
    <option value="0">Planning Antiguo</option>
    <option value="1">Planning Nuevo</option>
</select>

<template v-if="operarioscargados == true && desactivado == false">
    <!-- MAPA: igual para planning antiguo y nuevo -->
    <servicio-planning-mapa
        v-if="component == 'servicio-planning-mapa'"
        :key="'mapa' + componentKey"
        :fechacald="fechacald"
        :cambios="cambios"
        :guardia="guardia"
        :cargarcalend="cargarcalend"
        :asegurado="asegurado"
        :operarios="operarios"
        :operariosseleccionados="operariosseleccionados"
        :especioperarioseleccionado="especioperarioseleccionado"
        :visitas="visitas"
        :id="id"
        :geograficoActivado="geograficoActivado"
        :servicio="servicio"
        :cargars="cargar"
    />

    <template v-else>
        <!-- PLANNING ANTIGUO (vue-cal) -->
        <template v-if="mostrarplaningnuevo == 0">
            <div class="mx-4 my-3">
                <Slider @change="test1235()" :min="0" :max="maximoscroll" v-model="slider" class="w-full" />
            </div>
            <servicio-planning-calendario
                :key="componentKey"
                :fechacald="fechacald"
                :cambios="cambios"
                :guardia="guardia"
                :cargarcalend="cargarcalend"
                :asegurado="asegurado"
                :operarios="operarios"
                :operariosseleccionados="operariosseleccionados"
                :especioperarioseleccionado="especioperarioseleccionado"
                :visitas="visitas"
                :id="id"
                :geograficoActivado="geograficoActivado"
                :servicio="servicio"
                :cargars="cargar"
            />
        </template>

        <!-- PLANNING NUEVO (FullCalendar) -->
        <planning-fullcalendar
            v-else
            :key="componentKey"
            :id="id"
            @fecha-actual="fechaActualCalendario = $event"
            :asegurado="asegurado"
            :servicio="servicio"
            :operarios="operarios"
            :operariosseleccionados="operariosseleccionados"
            :especioperarioseleccionado="especioperarioseleccionado"
            :cambios="cambios"
            :guardia="guardia"
            :cargarcalend="cargarcalend"
            :cargars="cargar"
            :fechacald="fechacald"
            @visita-creada="$emit('visita-creada')"
        />
    </template>
</template>
                            <!--</keep-alive>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="col-md-4" v-if="visitas">
             <servicio-planning-visitas :id="id" :servicio="servicio" />
        </div>-->
    </div>
    <OverlayPanel :dismissable="true" ref="calend">

        <Calendar v-model="fechacald" inline />

    </OverlayPanel>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
import servicioplanningvisitas from '../datos/visitas/visitas.vue';
import servicioplanningcalendario from './planning_calendario.vue';
import servicioplanningmapa from './planning_mapa.vue';
import Checkbox from 'primevue/checkbox';
import OverlayPanel from 'primevue/overlaypanel';
import MultiSelect from 'primevue/multiselect';
import Slider from 'primevue/slider';
import Calendar from 'primevue/calendar';
import Textarea from 'primevue/textarea';
import planningfullcalendar from './planning_fullcalendar.vue';

export default ({
    props: ['id','servicio', 'cargar', 'servicioext', 'asegurado'],
    setup() {
        return;
    },
    components: {
            // eslint-disable-next-line vue/no-unused-components
        'servicio-planning-visitas': servicioplanningvisitas,
        'servicio-planning-calendario': servicioplanningcalendario,
        'servicio-planning-mapa': servicioplanningmapa,
        'planning-fullcalendar': planningfullcalendar,

        Checkbox, OverlayPanel, MultiSelect,Slider,Calendar,Textarea
    },
    data (){
        return {
            desactivado: false,
            operariosagrupados:[],
            errorPlanning:false,
            geograficoActivado: false,
            component: "servicio-planning-calendario",
            visitas: '',
            operarios: [],
            mostrarfiltrooperarios: false,
            operariosseleccionados: '',
            mostrarfiltroavz: true,
            especioperario: '',
            especioperarioseleccionado:'',
            marcas: '',
            propiedades_hora_fin:'',
            propiedades_hora_ini:'',
            fechaActualCalendario: new Date().toISOString().split('T')[0],
            marcaseleccionada: '',
            satactivado:false,
            sat: '',
            tiposservicio: '',
            tiposservicioseleccionado: '',
            cambios: false,
            clase: "col-md-12",
            icono: "fas fa-minus",
            guardia: '',
            iconomapa: "fas fa-map-marked-alt",
            titulo:"Mapa",
            operarioscargados: false,
            maximoscroll: 10000,
            slider: null,
            fechacald: null,
            gestiontipos: false,
            guardias: false,
            fechainicioipas: new Date(),
            fechafinipas: new Date(Date.now() + 60 * 60 * 1000),
            especiseleccionada:'',
            descripcionvisitaipas:'',
            mostrar: true,
            ipasespecialidad:'',
            ipasoperario:'',
            prestacionesipas:'',
            prestacionipasseleccionada:'',
            documentacionipas:'',
            camposrellenaripas:'',
            clientesipas:'',
            clienteipasseleccionado:'',
            visitasinterpwgs:'',
            operariosespecialidad:'',
            operariosespecialidadipas:'',
            cargarcalend: 0,
            soporte:0,
            mostrarplaningnuevo:1,
            rga:0,
            componentKey: 0
        }
    },
    methods: {
        mapacalendario() {
            if (this.iconomapa == "fas fa-map-marked-alt") {
                this.titulo = "Calendario";
                this.iconomapa = "fas fa-calendar-alt";
                this.component = "servicio-planning-mapa";
            }
            else {
                this.titulo = "Mapa";
                this.iconomapa = "fas fa-map-marked-alt";
                this.component = "servicio-planning-calendario";
            }
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        togglecalen(event) {
            this.$refs.calend.toggle(event);
        },
        // Devuelve 'aaaa-mm-dd' sin depender de toISOString (evita desfase de zona horaria)
        formatearFechaApi(fecha) {
            const f = (fecha instanceof Date && !isNaN(fecha.getTime())) ? fecha : new Date();
            return f.getFullYear() + '-' +
                String(f.getMonth() + 1).padStart(2, '0') + '-' +
                String(f.getDate()).padStart(2, '0');
        },
        async cargardocumentosIpas(){
            //GET /planning-pwgs/:id_cliente/formulario-visita?fecha=aaaa-mm-dd
            const idcliente = this.servicioext?.datos?.clientes_idcliente;
            if (!idcliente) return;
            const api = new PwgsApi();
            try {
                let aux = await api.get('planning-pwgs/' + idcliente + '/formulario-visita?fecha=' + this.formatearFechaApi(this.fechainicioipas));
                this.documentacionipas = aux?.visita_documentos || '';
                this.camposrellenaripas = aux?.visita_grupos || '';
                this.clientesipas = aux?.clientes_servicio || '';
            } catch (e) {
                console.log('Error al cargar documentos IPAS', e);
            }
        },
        test1235() {
            const dv = document.getElementsByClassName('day-view')[0];
            if (!dv) return;

            if (dv.scrollLeftMax) {
                this.maximoscroll = dv.scrollLeftMax;
            }
            if (dv.scrollWidth) {
                this.maximoscroll = dv.scrollWidth;
            }

            dv.scrollLeft = this.slider;
        },
        pruebascroll() {
            setTimeout(() => {
                let aux = document.getElementsByClassName('day-view')[0];
                if(aux) aux.addEventListener('scroll', this.pruebaexito)
            }, 4000);
        },
        pruebaexito() {
            const dv = document.getElementsByClassName('day-view')[0];
            if (!dv) return;

            this.slider = dv.scrollLeft;
            if (dv.scrollLeftMax) {
                this.maximoscroll = dv.scrollLeftMax;
            }
            if (dv.scrollWidth) {
                this.maximoscroll = dv.scrollWidth;
            }
        },
        cambiarclase() {
            if (this.clase == "col-md-8") {
                this.clase = "col-md-12";
                this.icono = "fas fa-minus";
                this.$parent.mostrarf();
            }
            else {
                this.clase = "col-md-8";
                this.icono = "fas fa-plus";
                this.$parent.mostrarf2();
            }
        },
        async cargarvisitasservicio() {
            //GET  modulos/pwgsapi/index.php/servicios/:id/visitas
            this.visitas = '';
            const api = new PwgsApi();
            const eq = await api.get('parametros-pwgs/gestion_de_equipos');
            if (eq.gestion_de_equipos == 1) {
                this.satactivado = true;
            }
            this.visitas = await api.get('servicios/' + this.$props.id + '/visitas');
        },
        reiniciaroperarios() {
            let aux = this.operariosseleccionados;
            this.operariosseleccionados = null;
            setTimeout(() => {
                this.operariosseleccionados = aux;
            }, 1000);
        },
        reiniciarfiltros() {
            this.cambios = false;
            this.marcaseleccionada = '';
            this.tiposservicioseleccionado = '';
            this.sat = '';
            this.especioperarioseleccionado = '';
            this.guardia = '';
            this.filtraroperarios();
           // this.reiniciaroperarios();
        },        
        reiniciarfiltrosmenosespecialidad() {
            this.cambios = false;
            this.marcaseleccionada = '';
            this.tiposservicioseleccionado = '';
            this.sat = '';
            this.guardia = '';
            var aux = this.especioperarioseleccionado;
            this.especioperarioseleccionado = '';
            setTimeout(() => {
                this.especioperarioseleccionado = aux;
            }, 2000);            
            //this.filtraroperarios();
        },
        async cargaroperarios() {
            //POST /modulos/pwgsapi/index.php/planning-pwgs/:id/operarios
            const api = new PwgsApi();
            const datos = await api.post("planning-pwgs/" + this.id + "/operarios");
            this.operarios = Object.values(datos || {});
            this.operarios.sort((a, b) => String(a?.nombre || '').localeCompare(String(b?.nombre || '')));

            var operariosgrupos = [
                {'label':'Contratados', 'items':[]},
                {'label':'Autónomos', 'items':[]}];
            this.operarios.forEach(operario => {
                if (operario.tipo_operario=='contratado'){
                    operariosgrupos[0].items.push(operario);
                }else{
                    operariosgrupos[1].items.push(operario);
                }
            });
            this.operariosagrupados = operariosgrupos;
            this.operarioscargados = true;
        },
        sort(a, b){
            return a.DepartmentName.localeCompare(b.DepartmentName);
        },
        async cargarespecialidadesoperarios() {
            //GET   modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/especialidades
            const api = new PwgsApi();
            let datos;
            datos = await api.get("planning-pwgs/" + this.$props.id + "/especialidades");
            this.especioperario = Object.values(datos || {});
            try{
                this.especioperario.sort((a, b) => String(a?.nombre || '').localeCompare(String(b?.nombre || '')));
            }
            catch(e){
                console.log("Error al ordenar especialidades", e);
            }
        },
        async cargarmarcas() {
            //GET  modulos/pwgsapi/index.php/tipos-marca
            const api = new PwgsApi();
            let datos;
            datos = await api.get("tipos-marca");    
            this.marcas = datos.datos;  
        },
        async cargartiposservicio() {
            //GET  modulos/pwgsapi/index.php/tipos-servicio
            const api = new PwgsApi();
            let datos;
            datos = await api.get("tipos-servicio");
            this.tiposservicio = datos.datos;
        },
        async cargarFranjaPlanning() {
            const idcliente = this.servicioext?.datos?.clientes_idcliente;
            if (!idcliente) return;

            const api = new PwgsApi();
            const fecha = this.formatearFechaApi(new Date());
            try {
                const datos = await api.get('planning-pwgs/' + idcliente + '/formulario-visita?fecha=' + fecha);
                this.propiedades_hora_ini = datos?.planning_hora_ini || '';
                this.propiedades_hora_fin = datos?.planning_hora_fin || '';
            } catch (e) {
                console.log('Error al cargar franja del planning', e);
            }
        },
        // --- INTERPWGS: una fecha por cada visita del v-for ---
        cambiarFechaInicioInter(visita, val) {
            if (!visita) return;

            visita.fecha_inicio_obj = this.limitarFranja(val);
            const inicio = visita.fecha_inicio_obj;
            if (!(inicio instanceof Date) || isNaN(inicio.getTime())) return;

            // Sin fecha fin previa: inicio + 1 hora
            if (!(visita.fecha_fin_obj instanceof Date) || isNaN(visita.fecha_fin_obj.getTime())) {
                visita.fecha_fin_obj = this.limitarFranja(new Date(inicio.getTime() + 60 * 60 * 1000));
                return;
            }

            // Mismo día que el inicio, conservando la hora que ya tenía la fecha fin
            const fin = new Date(visita.fecha_fin_obj);
            fin.setFullYear(inicio.getFullYear(), inicio.getMonth(), inicio.getDate());

            // Si la hora fin queda antes que la de inicio, se pone inicio + 1 hora
            if (fin <= inicio) {
                visita.fecha_fin_obj = this.limitarFranja(new Date(inicio.getTime() + 60 * 60 * 1000));
            } else {
                visita.fecha_fin_obj = this.limitarFranja(fin);
            }
        },
        // --- IPAS: formulario único, usa fechainicioipas / fechafinipas ---
        cambiarFechaInicioIpas(val) {
            this.fechainicioipas = this.limitarFranja(val);
            const inicio = this.fechainicioipas;
            if (!(inicio instanceof Date) || isNaN(inicio.getTime())) return;

            if (!(this.fechafinipas instanceof Date) || isNaN(this.fechafinipas.getTime())) {
                this.fechafinipas = this.limitarFranja(new Date(inicio.getTime() + 60 * 60 * 1000));
                return;
            }

            const fin = new Date(this.fechafinipas);
            fin.setFullYear(inicio.getFullYear(), inicio.getMonth(), inicio.getDate());

            this.fechafinipas = fin <= inicio
                ? this.limitarFranja(new Date(inicio.getTime() + 60 * 60 * 1000))
                : this.limitarFranja(fin);
        },
        esFechaValida(fecha) {
            return fecha instanceof Date && !isNaN(fecha.getTime());
        },
        async filtraroperarios() {
            //POST  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/operarios
            const api = new PwgsApi();
            let subidadatos = { };
            if (this.marcaseleccionada) { subidadatos.id_marca = this.marcaseleccionada; }
            if (this.especioperarioseleccionado) { subidadatos.id_especialidad = this.especioperarioseleccionado; }
            if (this.tiposservicioseleccionado) { subidadatos.id_tipo_servicio = this.tiposservicioseleccionado; }
            if (this.sat) { subidadatos.sat = this.sat; }
            if (this.guardia) { subidadatos.guardia = this.guardia; }
            if (this.guardia == false) { subidadatos.guardia = false; }
            if (this.fechaActualCalendario) {
                subidadatos.start = this.fechaActualCalendario + 'T00:00:00';
                subidadatos.end   = this.fechaActualCalendario + 'T23:59:59';
            }

            const respuesta = await api.post("planning-pwgs/" + this.$props.id + "/operarios", subidadatos);
            const operariosaux = Object.values(respuesta || {});

            this.operarios = operariosaux;
            this.operarios.sort((a, b) => String(a?.nombre || '').localeCompare(String(b?.nombre || '')));

            // operariosseleccionados es un array de IDs, no de objetos: no se ordena por nombre
            this.operariosseleccionados = this.operarios.map(op => op.idoperario);
        },
        async comprobarGeografico(){
            const api = new PwgsApi();
            const resp = await api.get('parametros-pwgs/planning_geografico');
            if(resp.planning_geografico == 1){
                this.geograficoActivado = true;            
            }
        },
        comprobartipodano() {
            if (this.servicioext) {
                this.errorPlanning = !this.servicioext?.datos?.tipo_danyo_servicio;
            }
        },
        async comprobarEquipos(){
            const api = new PwgsApi();
            const ia = await api.get('parametros-pwgs/gestion_de_equipos');
            if(ia['gestion_de_equipos']==1){
                this.equipos=true;
            }else{
                this.equipos=false;
            }
        },
        esCitaInterConfirmada(visita) {
    if (!visita) return false;
    return String(visita.confirmar_reparadora) === '0';
},
        async comprobarTiposServicio() {
            const api = new PwgsApi();
            let aux = await api.get('parametros-pwgs/gestion_tipos');
            if (aux.gestion_tipos == 1) {
                this.gestiontipos = true
            }
            else {
                this.gestiontipos = false
            }
        },
        async comprobarGuardias() {
            const api = new PwgsApi();
            let aux = await api.get('parametros-pwgs/guardias');
            if (aux.guardias == 1) {
                this.guardias = true;
            }
            else {
                this.guardias = false;
            }
        },
        async prestacionIpas(){
            const precita = this.$props.servicio?.precita_ipas;
            if (!precita) return;

            const api = new PwgsApi();
            try {
                this.prestacionesipas = await api.get('servicios/' + this.$props.id + '/prestaciones-ipas');
                if (Array.isArray(this.prestacionesipas) && this.prestacionesipas.length > 0) {
                    this.prestacionipasseleccionada = this.prestacionesipas[0].numero_prestacion;
                }
            } catch (e) {
                console.log('Error al cargar prestaciones IPAS', e);
            }

            this.cargardocumentosIpas();

            const fechaCita = this.convertirStringADate(precita.fecha_inicio_cita_pap_mensaje);
            if (fechaCita) {
                this.fechainicioipas = fechaCita;
                this.fechafinipas = new Date(fechaCita.getTime() + 60 * 60 * 1000);
            }
        },
        convertirStringADate(fechaStr) {
            if (!fechaStr) return null;

            const partes = String(fechaStr).trim().split(' ');
            const fecha = partes[0];
            const hora = partes[1];
            if (!fecha || !hora) return null;

            const [dia, mes, anio] = fecha.split('-');
            const [horas, minutos, segundos] = hora.split(':');
            if (!dia || !mes || !anio || horas === undefined || minutos === undefined) return null;

            const resultado = new Date(
                Number(anio),
                Number(mes) - 1,
                Number(dia),
                Number(horas),
                Number(minutos),
                Number(segundos || 0)
            );
            return isNaN(resultado.getTime()) ? null : resultado;
        },
        async comprobarInterpwgs(){
            if (!this.$props.servicio?.interpwgs) return;

            const api = new PwgsApi();
            try{
                const respuesta = await api.get('servicios/' + this.$props.id + '/visitasinterpwgs');
                this.visitasinterpwgs = Array.isArray(respuesta)
                    ? respuesta.map(v => ({
                        ...v,
                        fecha_inicio_obj: this.convertirStringADate(v.fecha_inicio_cita_pap_mensaje),
                        fecha_fin_obj: this.convertirStringADate(v.fecha_fin_cita_pap_mensaje),
                        especialidadseleccionada: '',
                        operarioseleccionado: '',
                        descripcion: '',
                        confirmar_cita: this.esCitaInterConfirmada(v) ? '' : 1,
                    }))
                    : '';
            }
            catch(e){
                console.log(e);
            }
        },
        async obtenerOperariosEspecialidad(idesp){
            const api = new PwgsApi();
            let subidadatos = {id_especialidad:idesp};
            let datos = await api.post("planning-pwgs/"+this.$props.id+"/operarios",subidadatos);
            this.operariosespecialidad = Object.values(datos || {});
            this.operariosespecialidad.sort((a, b) => String(a?.nombre || '').localeCompare(String(b?.nombre || '')));
        },
        async obtenerOperariosEspecialidadIpas(idesp){
            const api = new PwgsApi();
            let subidadatos = {id_especialidad:idesp};
            let datos = await api.post("planning-pwgs/"+this.$props.id+"/operarios",subidadatos);
            this.operariosespecialidadipas = Object.values(datos || {});
            this.operariosespecialidadipas.sort((a, b) => String(a?.nombre || '').localeCompare(String(b?.nombre || '')));
        },
        async enviarprecitaIpas(){
            //POST  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/crear-visita
            if (!this.esFechaValida(this.fechainicioipas) || !this.esFechaValida(this.fechafinipas)) {
                this.$toast.add({ severity: 'warn', summary: 'Fechas', detail: 'Debe indicar fecha de inicio y fecha de fin', life: 3000 });
                return;
            }

            const documentacionChecked = Object.values(this.documentacionipas || {}).filter(item => item.checked === "checked").map(item => item.id);
            const camposChecked = Object.values(this.camposrellenaripas || {}).filter(item => item.checked === "checked").map(item => item.id);

            let subidaclientes = {id:this.servicioext?.datos?.clientes_idcliente, descripcion:this.descripcionvisitaipas}
            var clientes = [];
            clientes.push(subidaclientes);
            let subidadatos = {visita_documentos:documentacionChecked, visita_grupos:camposChecked,gremio_servicio_mensaje:this.prestacionipasseleccionada,descripcion_cita:this.descripcionvisitaipas,id_operario:this.ipasoperario,
                fecha_cita_inicio:this.fechainicioipas.toLocaleDateString('es-ES', {  day: '2-digit',  month: '2-digit',  year: 'numeric'}), 
                fecha_cita_fin:this.fechafinipas.toLocaleDateString('es-ES', {  day: '2-digit',  month: '2-digit',  year: 'numeric'}),
                hora_cita_inicio: this.fechainicioipas.toLocaleTimeString('es-ES', { hour: '2-digit',  minute: '2-digit',  second: '2-digit',  hour12: false}),
                hora_cita_fin: this.fechafinipas.toLocaleTimeString('es-ES', { hour: '2-digit',  minute: '2-digit',  second: '2-digit',  hour12: false}),
                id_especialidad:this.ipasespecialidad,
                clientes:clientes,
                precita_ipas: 1,
            };
            const api = new PwgsApi();
            try{
                await api.post('planning-pwgs/' + this.$props.id + '/crear-visita',subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Cita creada', detail: 'Cita creada correctamente', life: 2000 });
                this.cargarcalend = this.cargarcalend +1;
            }
            catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async comprobarpermisos(){
            const api = new PwgsApi();
            let permisosusuario = [];
            let auxusuario = localStorage.getItem('usuario');
            const resppermisos = await api.get('usuarios/'+auxusuario+'/permisos');
            var permisos = resppermisos.datos;
            for(let permiso of permisos){
                permisosusuario.push(permiso.nombre_permiso);
            }
            if(permisosusuario.includes('soporte'))            {
                this.soporte = 1;
            }
            else{
                this.soporte = 0;
            }   
        },
        async enviarcitainterpwgs(visita){
            //POST  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/crear-visita
            if (!visita) return;
            if (!this.esFechaValida(visita.fecha_inicio_obj) || !this.esFechaValida(visita.fecha_fin_obj)) {
                this.$toast.add({ severity: 'warn', summary: 'Fechas', detail: 'Debe indicar fecha de inicio y fecha de fin', life: 3000 });
                return;
            }

            let subidaclientes = {id:this.servicioext?.datos?.clientes_idcliente, descripcion:visita.descripcion}
            var clientes = [];
            clientes.push(subidaclientes);
            let subidadatos = {descripcion_cita:visita.descripcion,id_operario:visita.operarioseleccionado,
                fecha_cita_inicio:visita.fecha_inicio_obj.toLocaleDateString('es-ES', {  day: '2-digit',  month: '2-digit',  year: 'numeric'}), 
                fecha_cita_fin:visita.fecha_fin_obj.toLocaleDateString('es-ES', {  day: '2-digit',  month: '2-digit',  year: 'numeric'}),
                hora_cita_inicio: visita.fecha_inicio_obj.toLocaleTimeString('es-ES', { hour: '2-digit',  minute: '2-digit',  second: '2-digit',  hour12: false}),
                hora_cita_fin: visita.fecha_fin_obj.toLocaleTimeString('es-ES', { hour: '2-digit',  minute: '2-digit',  second: '2-digit',  hour12: false}),
                id_especialidad:visita.especialidadseleccionada,
                clientes:clientes,
                confirmar_cita:visita.confirmar_cita,
                interpwgs_confirmar_reparadora:visita.confirmar_reparadora,
                interpwgs_visita_reparadora:visita.id_comunicacion_mensaje,
            };
            const api = new PwgsApi();
            try{
                await api.post('planning-pwgs/' + this.$props.id + '/crear-visita',subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Cita creada', detail: 'Cita creada correctamente', life: 2000 });
                this.comprobarInterpwgs();
                this.cargarcalend = this.cargarcalend +1;
            }
            catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async modificarPAS() {
            if (!this.servicio?.PAS) return;

            this.operarioscargados = false;
            let estadoCheckbox = this.servicio.PAS.rga;
            let subidadatos = { plataforma_pas: estadoCheckbox };
            const api = new PwgsApi();
            try{
                await api.put("servicios/" + this.$props.id + "/modificar-servicio", subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'RGA guardado correctamente', life: 2000 });

                await this.cargaroperarios(); 
                this.componentKey += 1;
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                this.operarioscargados = true;
            }
        },
       async comprobarparametroplanning() {
            const api = new PwgsApi();
            try {
                let aux = await api.get('parametros-pwgs/planning_nuevo');
                if (aux.planning_nuevo == 1) {
                    this.mostrarplaningnuevo = 1;
                }
                else {
                    this.mostrarplaningnuevo = 1;
                }
            } catch (error) {
                this.mostrarplaningnuevo = 1;
            }
        },
        parsearHora(valor, porDefecto) {
            if (valor === null || valor === undefined || valor === '') return porDefecto;
            const [h, m] = String(valor).split(':').map(Number);
            if (isNaN(h)) return porDefecto;
            return { h, m: isNaN(m) ? 0 : m };
        },
        limitarFranja(fecha) {
            if (!(fecha instanceof Date) || isNaN(fecha.getTime())) return fecha;

            const ini = this.parsearHora(this.propiedades_hora_ini, { h: 0, m: 0 });
            const fin = this.parsearHora(this.propiedades_hora_fin, { h: 23, m: 59 });

            const minutos = fecha.getHours() * 60 + fecha.getMinutes();
            const minIni = ini.h * 60 + ini.m;
            const minFin = fin.h * 60 + fin.m;

            if (minutos >= minIni && minutos <= minFin) return fecha;

            const ajustada = new Date(fecha);
            if (minutos < minIni) ajustada.setHours(ini.h, ini.m, 0, 0);
            else ajustada.setHours(fin.h, fin.m, 0, 0);
            return ajustada;
        },
    },
    mounted() {
        this.comprobartipodano();
        this.cargaroperarios();
        this.comprobarGeografico();
        this.cargarvisitasservicio();
        this.comprobarTiposServicio();
        this.comprobarGuardias();
        this.cargarespecialidadesoperarios();
        this.cargarmarcas();
        this.cargartiposservicio();
        this.component = "servicio-planning-calendario";
        this.pruebascroll();
        this.comprobarInterpwgs();
        this.prestacionIpas();
        this.comprobarpermisos();
        //this.comprobarparametroplanning();
        this.cargarFranjaPlanning();
    },
    unmounted() {
        window.removeEventListener('scroll', this.pruebaexito);
    },
    watch: {
        servicioext(){
            this.comprobartipodano();
            // servicioext puede llegar después del mounted: sin esto la franja horaria nunca se carga
            this.cargarFranjaPlanning();
        },
        servicio(){
            this.prestacionIpas();
            this.comprobarInterpwgs();
        },
        cargar(){
            //this.comprobarInterpwgs();
        },
        id() {
            this.cargaroperarios();
            this.comprobartipodano();
            this.comprobarGeografico();
            this.component = "servicio-planning-calendario";
            this.cargarvisitasservicio();
            this.cargarespecialidadesoperarios();
            this.reiniciarfiltros();
            this.iconomapa = "fas fa-map-marked-alt";
            this.prestacionIpas();
            this.comprobarInterpwgs();
            this.cargarFranjaPlanning();
        },
        tiposservicioseleccionado() {
            if (this.tiposservicioseleccionado) {
                this.cambios = true;
                this.filtraroperarios();
            }
            if (this.tiposservicioseleccionado == '') { this.operariosseleccionados = ''; this.cambios = false }
        },
        marcaseleccionada() {
            if (this.marcaseleccionada) {
                this.filtraroperarios();
            }
            if (this.marcaseleccionada == '') { this.operariosseleccionados = ''; this.cambios = false }
        },
        sat() {
            if (this.sat) {
                this.cambios = true;
                this.filtraroperarios();
            }
            if(this.sat==''){ this.operariosseleccionados = '';this.cambios = false }
        },
        guardia() {
          if (this.guardia == true || this.guardia == false) {
                this.cambios = true;
                this.filtraroperarios();
            }
            if (this.guardia == '') { this.operariosseleccionados = ''; this.cambios = false }
        },
        especioperarioseleccionado() {
            if (this.especioperarioseleccionado) {
                this.cambios = true;
                this.filtraroperarios();
            }
            if(this.especioperarioseleccionado==''){ this.operariosseleccionados = ''; this.cambios = false }
        },
        $route(){
            this.slider = 0;
        },
    }
})
</script>
<style>
</style>